var _excluded = ["children", "panel"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Heading from './heading';
import AccordionPanel from './accordionPanel';
var AccordionItemV2 = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      children,
      panel
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var content = panel || children;
  if (!content) {
    return /*#__PURE__*/React.createElement(Heading, rest, content);
  }
  return /*#__PURE__*/React.createElement(AccordionPanel, _extends({
    ref: ref
  }, rest), content);
});
AccordionItemV2.propTypes = {
  accordionId: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  defaultTypeStyle: PropTypes.string,
  expanded: PropTypes.bool,
  handleClick: PropTypes.func,
  heading: PropTypes.node.isRequired,
  /** CSS className to be applied to the <HeadingTag /> element */
  headingClassName: PropTypes.string,
  headingTag: PropTypes.string,
  /** CSS className to be applied to the wrapper of the <HeadingTag /> element - use for specifying a container class so the heading aligns to the grid */
  headingWrapperClassName: PropTypes.string,
  /** An SVG node to be displayed in the heading */
  icon: PropTypes.node,
  mobileTypeStyle: PropTypes.string,
  noShadow: PropTypes.bool,
  /** Accessible title for the closed state of the toggle icon */
  iconTitleClosed: PropTypes.string,
  /** Accessible title for the expanded state of the toggle icon */
  iconTitleExpanded: PropTypes.string,
  /** References stateKey prop to track Accordion */
  stateKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Deprecated: Deprecated: Use `children` instead. Panel content. */
  panel: PropTypes.node,
  size: PropTypes.string,
  panelContentClassName: PropTypes.string,
  panelContentRef: PropTypes.func,
  analyticsId: PropTypes.string,
  v2: PropTypes.bool,
  /** function is called before the open animation starts */
  onBeforeOpen: PropTypes.func,
  /** function is called after the open animation finishes */
  onAfterOpen: PropTypes.func,
  /** function is called before the close animation starts */
  onBeforeClose: PropTypes.func,
  /** function is called after the close animation finishes*/
  onAfterClose: PropTypes.func
};
AccordionItemV2.defaultProps = {
  accordionId: 'accordion',
  className: '',
  defaultTypeStyle: 'body-1',
  expanded: false,
  headingClassName: '',
  headingTag: 'h3',
  iconTitleClosed: '',
  iconTitleExpanded: '',
  mobileTypeStyle: '',
  size: 'small',
  panelContentClassName: '',
  headingWrapperClassName: '',
  noShadow: false,
  v2: false,
  children: null,
  handleClick: null,
  icon: null,
  stateKey: null,
  panel: null,
  panelContentRef: null,
  analyticsId: null,
  onBeforeOpen: null,
  onAfterOpen: null,
  onBeforeClose: null,
  onAfterClose: null
};
export default AccordionItemV2;